<script setup lang="ts">

import Application from "~/enums/Application";

const { t, locale } = useI18n();

const ogLocaleByCode: Record<string, string> = {
  ru: 'ru_RU',
  en: 'en_US',
  pl: 'pl_PL',
  lt: 'lt_LT'
};

useSeoMeta({
  description: () => t('head.description'),
  ogDescription: () => t('head.description'),
  keywords: () => t('head.keywords'),
  author: 'VVeb Developer',
  ogType: 'website',
  ogLocale: () => ogLocaleByCode[locale.value] ?? 'ru_RU',
  ogImage: absoluteUrl(`/images/belarusborder.png`),
});

useHead(appHead(Application.Default));
</script>

<template>
  <div class="container px-sm-4 py-sm-4 pt-0 pb-bottom-nav">
    <AppNavbar />
    <slot />
    <AppToaster />
    <AppFooter />
  </div>
  <AppBottomNav />
</template>